<template>
  <div :data-id="id">
    <q-field borderless :label="label" stack-label>
      <template v-slot:control>
        <div class="self-center full-width no-outline q-pt-xl">
          <q-range
            :value="filterInput"
            @change="handleFilterInputChange"
            :min="minValue"
            :max="maxValue"
            :step="1"
            label-always
          />
        </div>
      </template>
    </q-field>
  </div>
</template>
<script>
import { USER_RATING_MIN, USER_RATING_MAX } from "@/constants";
export default {
  name: "RatingRange",
  props: {
    id: {
      required: true,
      type: String,
      default: "",
    },
    label: {
      required: true,
      type: String,
      default: "",
    },
    items: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
    },
  },
  data() {
    return {
      filterInput: {
        min: USER_RATING_MIN,
        max: USER_RATING_MAX,
      },
      minValue: USER_RATING_MIN,
      maxValue: USER_RATING_MAX,
      enabled: false,
    };
  },
  mounted() {
    if (!this.filter) {
      this.filterInput.min = this.minValue;
      this.filterInput.max = this.maxValue;
    }

    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in rating range");

      this.reset();
    });
  },
  beforeDestroy() {
    this.$root.$off("reset-filter-input");
  },
  watch: {
    filterInput(newVal, oldVal) {
      if (newVal && oldVal) {
        if (newVal.min === oldVal.min && newVal.max === oldVal.max) {
          return;
        }
      }

      this.$emit("update", this.id, newVal);
    },
    minValue(newVal) {
      this.filterInput.min = newVal;
    },
    maxValue(newVal) {
      this.filterInput.max = newVal;
    },
    filter: {
      handler: function(newVal) {
        if (newVal) {
          const { min, max } = newVal;

          this.handleFilterInputChange({
            min,
            max,
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    reset() {
      const min = USER_RATING_MIN;
      const max = USER_RATING_MAX;
      const filterInput = this.filterInput;

      if (filterInput.min === min && filterInput.max === max) {
        return;
      }

      this.handleFilterInputChange({
        min,
        max,
      });
    },
    handleFilterInputChange(e) {
      this.filterInput = e;
    },
  },
};
</script>
<style lang="scss">
div[data-id="ratingCourseAvg"] .q-field__label,
div[data-id="ratingExperienceAvg"] .q-field__label {
  font-weight: bold;
}
</style>
